'use client';

import { Fragment } from 'react';

import { useTranslations } from 'next-intl';

import { modules } from '@/app.config';

import { Genre, MovieDetails } from '@/api/types/movie.types';

import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { SectionHeading } from '@/components/SectionHeading';

import { usePlayerContext } from '@/views/MovieDetailsView/MoviePlayerContext';
import styles from '@/views/MovieDetailsView/components/HeaderSection/HeaderSection.module.scss';

// =================================================================

interface HeaderSectionProps {
  title: string;
  hasSectionHeader?: boolean;
  genre: Genre;
  orginalTitle?: string;
}

// =================================================================

export const HeaderSection = (props: HeaderSectionProps) => {
  const { title, hasSectionHeader = true, genre, orginalTitle } = props;

  const { movieTitle, moduleId, movieId } = usePlayerContext();

  const t = useTranslations('layout');

  const moduleMovies = modules.find(mmodule => mmodule.id === moduleId.toString()) || modules[0];

  const breadcrumbLinks = [
    {
      href: `/movies/${moduleMovies?.id}`,
      label: t(moduleMovies?.title),
    },
    {
      href: `/movies/${moduleMovies?.id}?genres=${genre?.id}`,
      label: genre?.title,
    },
    { href: `/watch/${moduleId}/${movieId}`, label: orginalTitle || movieTitle },
    {
      href: '',
      label: title,
    },
  ];

  return (
    <Fragment>
      <div className={styles.breadcrumbsWrapper}>
        <Breadcrumbs links={breadcrumbLinks} />
      </div>
      {hasSectionHeader && (
        <SectionHeading as="h1" className="mb-4">
          {title}
        </SectionHeading>
      )}
    </Fragment>
  );
};
